import { useSelector } from 'react-redux';
import { PERMISSIONS } from 'constants/permissions';

export const useTokenData = () => {
  const { tokenData } = useSelector(state => state.site);
  const permissions = tokenData?.idTokenPayload['http://rapaport.com/permissions']?.diamondauction;
  const accountId = tokenData?.idTokenPayload['http://rapaport.com/user']?.sfMasterContactNumber;
  const isAdmin = permissions?.includes(PERMISSIONS.manageAuction);
  const isSeller = permissions?.includes(PERMISSIONS.acceptBid);
  const isBuyer = permissions?.includes(PERMISSIONS.listingBid);
  const isCanViewListing = permissions?.includes(PERMISSIONS.listingView);
  const givenName = tokenData?.idTokenPayload?.given_name;
  const nickName = tokenData?.idTokenPayload?.nickname;
  const email = tokenData?.idTokenPayload?.email;
  return {
    accountId,
    permissions,
    givenName,
    nickName,
    email,
    isAdmin,
    isSeller,
    isBuyer,
    isCanViewListing,
    isAuth: !!tokenData
  };
};
